import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { checkAuth } from '../store/slices/authSlice';
import { Loader2 } from 'lucide-react';
import { useGetCurrentUserQuery } from '../store/services/api';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { isAuthenticated, token, isLoading } = useAppSelector((state: { auth: { isAuthenticated: boolean; token: string | null; isLoading: boolean } }) => state.auth);

  // Check auth only when token changes
  useEffect(() => {
    if (token) {
      dispatch(checkAuth());
    }
  }, [token, dispatch]);

  // Payment success sayfası için özel kontrol
  const isPaymentSuccessPage = location.pathname === '/payment/success';
  const hasSessionId = location.search.includes('session_id=');
  
  // Payment success sayfası için token kontrolünü atla
  if (isPaymentSuccessPage && hasSessionId) {
    return <>{children}</>;
  }

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-[#FF4444] animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated || !token) {
    // Payment success sayfasından geliyorsa, session_id'yi koru
    if (location.state?.from?.pathname === '/payment/success' && location.state?.from?.search) {
      return <Navigate to={`/payment/success${location.state.from.search}`} replace />;
    }
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Skip user query if not authenticated or no token
  const { isLoading: userLoading } = useGetCurrentUserQuery(undefined, {
    skip: !token || !isAuthenticated || isPaymentSuccessPage
  });

  if (userLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-[#FF4444] animate-spin" />
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
